module.exports = __webpack_public_path__ + "img/knu_gallery0.54a40d76.jpg";